<template>
    <div class="sidebar">
        <div class="menu-container">
            <div class="left-menu-container" :class="{ small: isChangeMenu }">
                <div class="left-menu-item"
                     :class="((currentMenu == '/index-panel' && menuIten.path == '/index') || currentMenu == menuIten.path) ? 'active' : ''"
                     @click="clickMenu(menuIten)"
                     :key="'menuIten'+menuIndex"
                     v-for="(menuIten, menuIndex) in menu">
                    <svg-icon :icon-class="menuIten.meta.icon"></svg-icon>
                    <!-- <p></p> -->
                    <span v-if="!isChangeMenu">{{menuIten.meta.msg}}</span>
                    <div class="menu-item-tips" v-if="isChangeMenu">{{menuIten.meta.title}}</div>
                </div>
            </div>
            <div class="right-menu-container" v-if="hasSubMenu">
                <div class="shadow_top" ></div>
                <div v-if="subMenu.length > 0">
                    <div v-if="false" class="second-menu-name">{{secondMenuName}} <p></p> </div>
                    <el-menu
                            :default-active="currentActive"
                            v-for="(secondItem, secondIndex) in subMenu"
                            :default-openeds="openeds"
                            :key="'secondItem'+secondIndex"
                            @open="handleOpen"
                            @close="handleClose"
                            router
                            class="el-menu-vertical-demo">
                        <el-submenu :index="secondItem.path" v-if="secondItem.children.length > 0 && !secondItem.meta.lastLevelMenu" style="padding-left:0" :popper-append-to-body="false">
                            <span slot="title">{{secondItem.meta.title}}</span>
                            <el-menu-item class="thirdItemWrap" :index="thirdItem.path" v-for="(thirdItem, i) in secondItem.children" :key="'thirdItem'+i"style="padding-left:0" >
                                <span class="thirdItem" :class="(activePath == thirdItem.path || currentActive == thirdItem.path )? 'subItemActive' : '' ">{{thirdItem.meta.title}}</span>
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item claaa="secondItemWrap" :index="secondItem.path" v-else style="padding-left:0">
                            <span class="secondItem" :class="(activePath == secondItem.path || currentActive == secondItem.path) ? 'subItemActive' : '' ">{{secondItem.meta.title}}</span>
                        </el-menu-item>
                    </el-menu>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'sidebar',
        data() {
            return {
                hasSubMenu: false,
                secondMenuName: '',
                subMenu: [],
                openeds:['/setting','/setting-visitor-info'],
                tabOpends: true,
                isChangeMenu:false
            }
        },
        computed: {
            menu() {
                let routes = []
                if (this.$store.state.permission.addRoutes && this.$store.state.permission.addRoutes.length > 0) {
                    this.$store.state.permission.addRoutes.map((item, i) => {
                        if (item.name == 'layout') {
                            item.children.map((item) => {
                                if (this.currentMenu == item.path) {
                                    this.secondMenuName = item.meta.title
                                    this.subMenu = item.children
                                    // console.log(item)
                                    // this.openeds.push(item.path)
                                    // if(this.tabOpends && item.children.children) {
                                    //     item.children.children.map(pathItem => {
                                    //         this.openeds.push(pathItem.path)
                                    //     })
                                    // }
                                    if (this.currentMenu == '/index') {
                                        this.hasSubMenu = false
                                    }
                                }
                            })

                            routes = item.children
                        }
                    })
                }
                return routes
            },
            currentMenu() {
                if (this.$route.matched.length >= 3) {
                    this.hasSubMenu = true
                    return this.$route.matched[1].path
                } else {
                    return this.$route.path
                }
            },
            currentActive() {
                console.log(this.$route.matched)
                if (this.$route.matched.length > 3) {
                    return this.$route.matched[3].path
                } else {
                    return this.$route.path
                }
            },
            activePath(){
                if (this.$route.matched.length > 4) {
                    return  this.$route.matched[3].path
                } else if (this.$route.matched.length == 4) {
                    return  this.$route.matched[2].path
                }else {
                    return this.$route.path
                }

            }
        },
        methods: {
            handleOpen(key, keyPath) {
                console.log('openeds=', this.openeds)
            },
            handleClose(key, keyPath) {
                this.tabOpends = false
            },
            clickMenu (menuItem) {
                // this.hasSubMenu = false
                this.subMenu = []
                this.$nextTick(() => {
                    this.$router.push({
                        path: menuItem.path
                    })
                    this.secondMenuName = menuItem.meta.title
                    this.subMenu = menuItem.children
                    this.hasSubMenu = menuItem.children.length > 0 && menuItem.path != '/index';
                })
            },
        },
        mounted() {
            eventBus.$on("isChangeMenuType", (msg) => {
                // navBar发送来的消息
                this.isChangeMenu = msg;
            });
            console.log('currentActive=', this.currentActive)
        }
    }
</script>

<style lang="scss">
    .sidebar {
        // z-index: 1000;
        z-index: inherit!important;
        position: relative;
        background-color: #1d2c36;

        .menu-container{
            display: flex;
            height: 100%;
            // color: #fff;
            .left-menu-container{
                width: 200px;
                height: 100%;
                &.small{
                    width: 60px;
                    height: 50px;
                    .left-menu-item {
                        padding: 13px 0 12px 19px;
                    }
                }
                .left-menu-item{
                    padding: 13px 0 12px 25px;
                    // text-align: center;
                    box-sizing: border-box;
                    cursor: pointer;
                    position: relative; 
                    .svg-icon{
                        -webkit-filter: drop-shadow(0px 0px #09487a) saturate(0.075) brightness(100%);
                        filter: drop-shadow(0px 0px #09487a) saturate(0.075) brightness(100%);
                        width: 22px;
                        height: 22px;
                        margin-right: 0;
                    }
                    // p{
                    //     line-height: 1;
                    //     height: 20px;
                    //     margin-top: -10px;
                    //     font-size: 13px;
                    //     background-color: #8596aa;
                    // }
                    span{
                        line-height: 1;
                        margin-top: 6px;
                        font-size: 13px;
                        color: #808d8a;
                        margin-left: 25px;
                    }
                    .menu-item-tips{
                        display: none;
                        position: absolute;
                        left: 70px;
                        top: 50%;
                        background-color: #2f323a;
                        transform: translateY(-50%);
                        color: #fff;
                        font-size: 12px;
                        padding: 6px 8px;
                        border-radius: 3px;
                        z-index: 999;
                        white-space: nowrap;
                        &:before{
                            content: "";
                            width: 0px;
                            height: 0px;
                            border-top: 5px solid transparent;
                            border-bottom: 5px solid transparent;
                            border-right: 5px solid #2f323a;
                            position: absolute;
                            top: 6px;
                            left: -5px;
                        }
                    }
                    &.active{
                        background-color: #233543;
                        .svg-icon{ 
                            -webkit-filter: none;
                            filter: none;
                        }
                        span {
                            color: #02b28e;
                        }
                        // &:first-child{         
                        //     box-sizing: border-box;              
                        //     border-top:1px solid #eee;
                        // }
                    }
                    &:hover{
                        &:first-child{ 
                            box-sizing: border-box;            
                            // border-top:1px solid #eee;
                        }
                        background-color: #233543;
                        color: #02b28e;
                        .svg-icon{
                            -webkit-filter: none;
                            filter: none;
                        }
                        span {
                            color: #02b28e;
                        }
                        .menu-item-tips{
                            display: block;
                        }
                    }
                }
            }
            .right-menu-container{
				&:hover{
					&::-webkit-scrollbar{
						display: block;
						width: 8px;
					}
					&::-webkit-scrollbar-thumb{
						background-color: #ddd;
					}
				}
                flex: 1;
                width: 240px;
                background-color: #fff;
                height: 100%;
                overflow-y: auto;
                text-align: center;
                padding: 15px 0 20px;
                box-sizing: border-box;
                border-top:1px solid #eee;
                .second-menu-name{
                    font-weight: bold;
                    font-size: 14px;
                    line-height: 24px;
                    text-align: center;
                    p {
                        width:30px;
                        height: 2px;
                        background-color: #0089ff; 
                        margin: 0 auto 16px;
                    }
                }
                .el-menu,
                .el-menu-item,
                .el-submenu__title{
                    background-color: #fff;
                    color: #333;
                    box-sizing: border-box;
                    font-size: 13px;
                    // margin-bottom:2px;
                }
                .el-menu{
                    border-right: 0;
                }
                .el-submenu__icon-arrow{
                    right: initial;
					left: 12px;
                    color: #333;
					transform: rotateZ(-90deg);
                }
				.el-icon-arrow-down:before{
					content: "\E790"; // 改成实心箭头
				}
				.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
					transform: rotateZ(0deg);
				}
                .el-submenu {
                    text-align: left;
                    .el-menu-item{
                        min-width: 0;
                    }
                }
                .el-submenu__title,
                .el-menu-item,
                .third-menu{
                    height: 40px;
                    line-height: 40px;
                }
                .el-submenu__title,
                .el-menu-item {
                    padding: 0;
                    padding-left: 0;
                }
				.el-submenu__title{
					padding-left: 30px;
				}
                 .el-submenu__title span{
                     padding-left:10px
                 }
                .third-menu{
                    font-size: 13px;
                }
                // .thirdItemWrap,
                // .secondItemWrap{
                //     padding: 0 10px!important;
                // }
                .thirdItemWrap{
                    text-indent: 45px;
                }
                .secondItem{
                    display: block;
                    padding: 0;
                    // border-radius:  3px;
                    // margin: 2px 0;
                    text-indent: 45px;
                    text-align: left;
                    &.subItemActive{
                        background-color: #f5f6fa;
                        color:#141517;   
                        border-right: 3px solid #00b38b;
                    }
                    &:hover{
                        background-color: #f5f6fa;
                        border-right: 3px solid #00b38b;
                    }
                }
                .thirdItem{
                    // color: #c0e2ff;
                    color:#717574;
                    display: block;
                    padding: 0;
                    // border-radius: 5px;
                    // margin: 2px 0;
                    &.subItemActive{
                        color:#141517;   
                        background-color: #f5f6fa;
                        border-right: 3px solid #00b38b;
                        // border-radius: 3px;
                    }
                    &:hover{
                        // background-color: #357cb8;
                        color:#141517;   
                        background-color: #f5f6fa;
                        border-right: 3px solid #00b38b;
                    }
                }

            }
        }
    }

</style>
